import { GridController, gridTpl } from '../../../../common/grid/grid.controller';
import { IDS } from '../settings-action-id.constants';
import * as Actions from './slo-required-docs.actions';

class SloRequiredDocsGridController extends GridController {
    constructor($ngRedux, $state, NavigationService, AuthService, $filter, $mdDialog, $scope) {
        super($ngRedux, $state, NavigationService, $filter, $mdDialog);
        this.$scope = $scope;
        this.AuthService = AuthService;
    }

    $onInit() {
        this.module = 'accreditation';
        this.identifier = IDS.accSettings;
        this.statePath = IDS.sloRequiredDocsGrid;
        this.filterOpen = true;
        this.filterExpandButtonVisible = false;
        this.exportComponent = false;
        this.confirmDialogOnRemove = true;
        this.autoload = false;
        this.icon = false;

        this.isAdmin = this.AuthService.getUser().type === 'Administrator';

        this.columnsDefault = [
            {title: '#',                                                            mapper: null},
            {title: this.$filter('translate')(`COMMON.DOCUMENT.NUMBER`),            mapper: 'doc_num'},
            {title: this.$filter('translate')(`COMMON.FIELD.TYPE`),                 mapper: 'type_name'},
            {title: this.$filter('translate')(`COMMON.FIELD.SITE_LOCATION`),        mapper: 'location'},
            {title: this.$filter('translate')(`COMMON.FIELD.NAME`),                 mapper: 'name'},
            {title: this.$filter('translate')(`ACCREDITATION.COMMON.REQUIREMENTS`),    mapper: 'requirementsColumn'},
        ];
        this.columns = this.columnsDefault.concat();

        this.unsubscribe = this.$ngRedux.connect(this.mapState().bind(this), Actions)(this);
        this.unsubscribeCustom = this.$ngRedux.connect(state => {
            const sloRequiredDocsGrid = state.accreditation.accSettings.sloRequiredDocsGrid;
            return {
                selectedHeadOfficeUuid:   sloRequiredDocsGrid.selectedHeadOfficeUuid,
                overrideColumns:          sloRequiredDocsGrid.override.columns
            }
        }, {})(this);

        this.dataAction = this.fetchSloRequiredDocsGrid;

        this.buttons.push({
            class: 'btnGridAction',
            label: 'Download',
            callback: event => {
                this.onDownload(event);
            },
            filter: item => {
                return item.sample_doc_uri
            },
        });
        this.init();
    }

    $onDestroy() {
        this.destroy();
        if(this.unsubscribeCustom)
            this.unsubscribeCustom();
    }
}

SloRequiredDocsGridController.$inject = ['$ngRedux', '$state', 'NavigationService', 'AuthService', '$filter', '$mdDialog', '$scope'];

export const sloRequiredDocsGrid = {
    bindings: {
        onSelect: '&',
        onRemove: '&',
        onDownload: '&',
    },
    controller: SloRequiredDocsGridController,
    ...gridTpl
}
